var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigXDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4104 0.330969C14.9669 -0.110323 14.3017 -0.110323 13.8583 0.330969L8.09342 6.28842L2.32856 0.330969C1.88511 -0.110323 1.21993 -0.110323 0.776481 0.330969C0.333031 0.772262 0.333031 1.4342 0.776481 1.87549L6.54134 7.83294L0.554756 13.7904C0.111305 14.2317 0.111305 14.8936 0.554756 15.3349C0.776481 15.5556 0.998207 15.5556 1.21993 15.5556C1.44166 15.5556 1.88511 15.5556 1.88511 15.3349L7.64997 9.37746L13.4148 15.3349C13.6366 15.5556 13.8583 15.5556 14.08 15.5556C14.3017 15.5556 14.5235 15.5556 14.7452 15.3349C15.1886 14.8936 15.1886 14.2317 14.7452 13.7904L9.6455 7.83294L15.6321 1.87549C15.8538 1.4342 15.8538 0.772262 15.4104 0.330969Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigXDark);
export default __webpack_public_path__ + "static/media/bigXDark.f9f7c62a633b2911c2d7ea2b3ac06cfc.svg";
export { ForwardRef as ReactComponent };